import React, { ReactNode } from "react";
import classNames from "classnames";
import { CancelIcon } from "@/icons/primary-icons-new";

const TITLE_CLASSES = ["text-lg", "font-sans-serif"];
const BASE_CLASSES = ["font-sans-serif", "bg-white", "shadow-sm", "relative"];

const ROUNDED = {
  sm: "rounded-sm",
  base: "rounded-base",
  lg: "rounded-lg",
};

export type CaPanelProps = {
  title?: ReactNode;
  additionalTitle?: ReactNode;
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  rounded?: keyof typeof ROUNDED;
  onClose?: () => void;
};

export function CaPanel({
  title,
  children,
  className,
  additionalTitle,
  noPadding,
  rounded = "base",
  onClose,
}: CaPanelProps) {
  return (
    <div className='relative'>
      {onClose && (
        <div className='absolute top-2 right-3 cursor-pointer z-10' onClick={onClose}>
          <CancelIcon color='#5E678C' backgroundColor='transparent' style={{ width: 24 }} />
        </div>
      )}
      {(title || additionalTitle) && (
        <div className={classNames("flex", "items-center", "mb-5")}>
          {title && <div className={classNames(TITLE_CLASSES)}>{title}</div>}
          {additionalTitle && <div className='pl-5'>{additionalTitle}</div>}
        </div>
      )}
      <div className={classNames(BASE_CLASSES, !noPadding && "p-8", ROUNDED[rounded], className)}>
        {children}
      </div>
    </div>
  );
}

export default CaPanel;
